import React from "react";

export const getInitials = (firstName = "", lastName = "", email = "") => {
  const first = (firstName || "").trim();
  const last = (lastName || "").trim();
  if (first && last) return `${first[0]}${last[0]}`.toUpperCase();
  const fallback = (first || email || "").trim();
  return fallback ? fallback.slice(0, 2).toUpperCase() : "--";
};

export const getContactName = (firstName = "", lastName = "", email = "") =>
  [firstName, lastName].filter(Boolean).join(" ").trim() || email || "--";

// Initials circle: outlined for contacts, filled for the logged-in user's own messages.
const Avatar = ({ initials = "", filled = false, size = "" }) => (
  <span
    className={`inboxV2Avatar ${filled ? "filled" : ""} ${
      size === "sm" ? "sm" : ""
    }`}
  >
    {initials}
  </span>
);

export default Avatar;
